window.Smsauth = function (params) {
    this.blockCode = params.blockCode;
    this.blockCodeNode = $('#' + this.blockCode);
    this.fieldPhoneNode = params.fieldPhoneNode ? params.fieldPhoneNode[0] : false;
    this.fieldEmailNode = params.fieldEmailNode ? params.fieldEmailNode[0] : false;
    this.currentFieldNode = this.fieldPhoneNode ? this.fieldPhoneNode : this.fieldEmailNode;
    this.fieldEdit = this.blockCodeNode.find('[data-type="edit-field"]')[0];
    this.codeFieldNode = this.blockCodeNode.find('[name="'+params.fieldCodeNode+'"]').prevObject[0];
    this.fieldCodeEdit = this.blockCodeNode.find('[data-type="edit-code"]')[0];
    this.imgTitlefield = this.blockCodeNode.find('[data-type="img-label-field"]');
    this.messageTitlefield = this.blockCodeNode.find('[data-type="message-label-field"]');

    this.formNode = params.form[0];

    this.config = params.option;
    this.mode = params.mode;
    this.fieldValue = '';
    this.fieldType = '';
    this.blockReapitCode = true;

    // timer
    this.timerId = null;
    this.deadline = null;
    this.$hours = this.blockCodeNode.find('.timer__hours')[0];
    this.$minutes = this.blockCodeNode.find('.timer__minutes')[0];
    this.$seconds = this.blockCodeNode.find('.timer__seconds')[0];

    this.addEvents();
};

window.Smsauth.prototype = {

    addEvents: function () {
        if (this.currentFieldNode) {
            this.currentFieldNode.addEventListener('input', (e) => {
                this.changeField(e);
            });
        }
        if (!!this.fieldPhoneNode) {
            const maskPhone = new BX.MaskedInput({
                mask: window.phoneMasks.RU,
                input: this.currentFieldNode,
                definitions: [{
                    "rule": "[0-9]",
                    "char": "#",
                }],
                placeholder: '_',
            });

            const phone = new BX.PhoneNumber.Input({
                node: this.currentFieldNode,
                flagNode: BX('flag'),
                flagSize: 24,
                defaultCountry: 'ru',
                onChange: function (e) {
                    maskPhone.setMask(window.phoneMasks[e.country]);
                }
            });

            this.currentFieldNode.placeholder = '+7';
            this.mask = maskPhone;
            BX.addCustomEvent(maskPhone, 'change',BX.delegate( this.changeField, this));
        }

        this.codeFieldNode.addEventListener('input', (e) => {
            this.changeCode(e);
        });

        this.fieldEdit.addEventListener('click', (e) => {
            this.editFieldValue(e);
        });

        this.fieldCodeEdit.addEventListener('click', (e) => {
            this.editCode(e);
        });

        if(this.formNode){
            BX.bind(this.formNode, 'submit', this.submitForm.bind(this, this));
        }
    },

    changeField: function (e) {
        let elem = this.currentFieldNode;
        this.fieldType = elem.getAttribute('data-type');
        this.fieldValue = elem.value;

        let isValid = false;

        if (this.fieldType == 'email') {
            isValid = this.validateEmail();
        }

        if (this.fieldType == 'phone') {
            if (this.mask.test(this.mask.getValue())){
                isValid = true;
                this.fieldValue = this.fieldValue.replace('(', '').replace(')', '').replaceAll('-', '');
                elem.value = this.fieldValue;
            }
        }

        if (isValid) {
            const classObject = this;

            BX.ajax.runAction('sotbit:smsauth.' + this.mode + '.sendCode', {
                data: {
                    fieldValue: this.fieldValue,
                    type: 'registration',
                    typeField: this.fieldType
                },
            }).then(function (response) {
                data = JSON.parse(response.data);
                labelField = classObject.blockCodeNode.find('[data-type="label-field"]')[0];
                labelField.innerHTML = data;

                classObject.hiddenBlockField(e);
                classObject.viewedBlockCode();

                date = new Date();
                deadlene = date.getSeconds() + Number(classObject.config.breakTime);
                date.setSeconds(deadlene)
                classObject.deadline = date;
                classObject.countdownTimer();
                classObject.timerId = setInterval(classObject.countdownTimer.bind(classObject), 1000);

            }, function (response) {
                let errors = response.errors;
                classObject.viewedError(e.target, errors);
            });
        }
    },

    changeCode: function (e) {
        let elem = e.target;

        if (elem.value.length > elem.maxLength)
            elem.value = elem.value.slice(0, elem.maxLength);

        if (elem.value.length == elem.maxLength) {

            let fieldForm = {
                code: elem.value,
                fieldValue: this.fieldValue,
            };

            const classObject = this;

            BX.ajax.runAction('sotbit:smsauth.' + this.mode + '.checkCode', {
                data: fieldForm,
            }).then(function (response) {
                classObject.imgTitlefield.show();
                classObject.blockCodeNode.find('[name="CONFIRMATION_CODE"]').parent().parent().hide();
                classObject.blockCodeNode.find('.alert-code-phone').hide();
                classObject.messageTitlefield[0].innerHTML = classObject.fieldType == 'email' ? BX.message('REGISTER_FIELD_EMAIL_TO_SUCCESS') : BX.message('REGISTER_FIELD_PHONE_TO_SUCCESS') ;
                $(classObject.fieldEdit).hide();
                classObject.codeSuccess = true;
            }, function (response) {
                let errors = response.errors;

                if (!!errors) {
                    classObject.blockCodeNode.find('.alert-code-phone').empty();
                    classObject.blockCodeNode.find('.alert-code-phone').show();
                    for (let i = 0; i < Object.keys(errors).length; i++) {
                        if (!!errors[i].message) {
                            tmp = document.createElement("div");
                            tmp.innerHTML = errors[i].message;
                            classObject.blockCodeNode.find('.alert-code-phone').append(tmp);
                        }
                    }
                    classObject.codeSuccess = true;
                }

                classObject.blockCodeNode.find('[name="CONFIRMATION_CODE"]').css('border-color', '#E31C1C');
            });

        }
    },

    editFieldValue: function (e) {
        BX.ajax.runAction('sotbit:smsauth.' + this.mode + '. ', {
            data: {
                fieldValue: this.fieldValue
            },
        }).then(function (response) {
            // not action
        }, function (response) {
            //console.log(response);
        });

        this.viewedBlockField();
        this.hiddenedBlockCode();


        date = new Date();
        deadlene = date.getSeconds() + Number(this.config.breakTime);
        date.setSeconds(deadlene)
        this.deadline = date;
        this.countdownTimer();
        this.timerId = setInterval(this.countdownTimer.bind(this), 1000);
    },

    editCode: function (e) {
        if (!this.blockReapitCode) {
            var classObject = this;

            BX.ajax.runAction('sotbit:smsauth.' + this.mode + '.sendCode', {
                data: {
                    fieldValue: this.fieldValue,
                    type: 'registration',
                    typeField:  this.fieldType
                },
            }).then(function (response) {
                data = JSON.parse(response.data);
                labelField = classObject.blockCodeNode.find('[data-type="label-field"]');
                labelField.innerHTML = data;
            }, function (response) {
                console.log(response);
            });
        }

        this.hiddenEditCode();
        date = new Date();
        deadlene = date.getSeconds() + Number(this.config.breakTime);
        date.setSeconds(deadlene)
        this.deadline = date;
        this.countdownTimer();
        this.timerId = setInterval(this.countdownTimer.bind(this), 1000);
        this.viewedTimer();

    },

    submitForm: function (item, e) {
        if(item.codeSuccess){
            this.currentFieldNode.value = this.currentFieldNode.value.replace(' ', '');
            return true;
        }else{
            if (e) {
                e.preventDefault();
            }

            const registerForm = document.querySelector('.js_person_type_block[style=""] #company-register');
            const errorBlock = document.querySelector(".bitrix-error");
            errorBlock.innerHTML = '<label class="validation-invalid-label errortext">'+BX.message('REGISTER_SUBMIT_ERROR')+'<label></label></label>';
            document.querySelector('.content').scroll({
                top:0,
                left: 0,
                behavior: "smooth",
            });
            return false;
        }
    },

    countdownTimer: function () {
        const diff = this.deadline - new Date();

        if (diff <= 0) {
            this.hiddenTimer();
            this.viewedEditCode();
            this.blockReapitCode = false;
            clearInterval(this.timerId);
        }

        const hours = diff > 0 ? Math.floor(diff / 1000 / 60 / 60) % 24 : 0;
        const minutes = diff > 0 ? Math.floor(diff / 1000 / 60) % 60 : 0;
        const seconds = diff > 0 ? Math.floor(diff / 1000) % 60 : 0;


        if (hours != 0)
            this.$hours.textContent = hours < 10 ? '' + hours + ':' : hours + ':';

        this.$minutes.textContent = minutes < 10 ? '0' + minutes + ':' : minutes + ':';

        this.$seconds.textContent = seconds < 10 ? '0' + seconds : seconds;
    },

    hiddenTimer: function () {
        this.blockCodeNode.find('.block-timer').hide();
    },

    viewedTimer: function () {
        this.blockCodeNode.find('.block-timer').show();
    },

    viewedEditCode: function () {
        this.blockCodeNode.find('[data-type="edit-code"]').removeAttr("style");
        this.blockCodeNode.find('[data-type="edit-code"]').show();
    },

    hiddenEditCode: function () {
        this.blockCodeNode.find('[data-type="edit-code"]').hide();
    },

    validateEmail: function () {
        const EMAIL_REGEXP =  /^[A-Za-z0-9_.-]+@[A-Za-z0-9_.-]+\.[A-Za-z]{2,4}$/;
        return EMAIL_REGEXP.test(this.fieldValue);
    },

    viewedError: function (target, errors) {
        if (!!errors) {
            nodeError = document.createElement("span");
            nodeError.className = "alert-code-phone";
            nodeError.innerHTML = '';

            for (let i = 0; i < Object.keys(errors).length; i++) {
                if (!!errors[i].message) {
                    tmp = document.createElement("div");
                    tmp.innerHTML = errors[i].message;
                    nodeError.append(tmp);
                }
            }
            nodeError.style.display = 'block';
            target.parentNode.append(nodeError);
        }
    },

    hiddenBlockField: function (e) {
        $(this.currentFieldNode).parent().parent().hide();
    },

    viewedBlockField: function () {
        $(this.currentFieldNode).parent().parent().show();
    },

    hiddenedBlockCode: function () {
        this.blockCodeNode.hide();
    },

    viewedBlockCode: function () {
        this.blockCodeNode.removeAttr("style");
        this.blockCodeNode.show();
    }
}
